import { COLOR_SET_CLASSES, customTV } from '../../utils/tailwind';
export const DEFAULT_SIZE = 48;
export const DEFAULT_VARIANT = 'primary';
export const BUTTON_BASE_CLASSES = [
    'inline-flex',
    'items-center',
    'font-medium',
    'no-underline',
    'border-solid',
    'antialiased',
    'focus:outline-none',
    'focus-visible:shadow-[0_0_0_3px_theme(colors.background-default),0_0_0_5px_theme(colors.content-default)]',
    'dark:focus-visible:shadow-[0_0_0_3px_theme(colors.background-default-dark),0_0_0_5px_theme(colors.content-default-dark)]',
    'w-[var(--width,inherit)]',
];
const { 'interactive.primary': primary, 'interactive.secondary': secondary, 'interactive.critical': critical, 'interactive.contrast': contrast, 'interactive.primary.disabled': disabled, default: defaultColorSet, } = COLOR_SET_CLASSES;
export const buttonVariants = customTV({
    base: [...BUTTON_BASE_CLASSES, 'justify-center'],
    variants: {
        variant: {
            primary: [
                ...primary.default.content,
                ...primary.default.background,
                'hover:bg-interactive-primary-hover',
                'dark:hover:bg-interactive-primary-hover-dark',
                'active:bg-interactive-primary-pressed',
                'dark:active:bg-interactive-primary-pressed-dark',
                'bg-gradient-to-r from-[#d9d9d9]/20 to-[#d9d9d9]/0',
            ],
            secondary: [
                ...secondary.default.content,
                ...secondary.default.background,
                'hover:bg-interactive-secondary-hover',
                'active:bg-interactive-secondary-pressed',
                'dark:active:bg-interactive-secondary-pressed-dark',
                'dark:hover:bg-interactive-secondary-hover-dark',
            ],
            text: [
                ...secondary.default.content,
                'bg-transparent',
                'hover:bg-interactive-text-hover',
                'dark:hover:bg-interactive-text-hover-dark',
                'active:bg-interactive-text-pressed',
                'dark:active:bg-interactive-text-pressed-dark',
                'border',
                ...defaultColorSet.default.border,
            ],
            alternativeText: [
                ...secondary.default.content,
                'bg-transparent',
                'hover:bg-interactive-text-hover',
                'dark:hover:bg-interactive-text-hover-dark',
                'active:bg-interactive-text-pressed',
                'dark:active:bg-interactive-text-pressed-dark',
                ...defaultColorSet.default.border,
            ],
            critical: [
                ...critical.default.content,
                ...critical.default.background,
                'hover:bg-interactive-critical-hover',
                'dark:hover:bg-interactive-critical-hover-dark',
                'active:bg-interactive-critical-pressed',
                'dark:active:bg-interactive-critical-pressed-dark',
            ],
            contrast: [
                ...contrast.default.content,
                ...contrast.default.background,
                'hover:bg-interactive-contrast-hover',
                'dark:hover:bg-interactive-contrast-hover-dark',
                'active:bg-interactive-contrast-pressed',
                'dark:active:bg-interactive-contrast-pressed-dark',
            ],
            disabled: [...disabled.default.content, ...disabled.default.background, 'cursor-not-allowed'],
        },
        size: {
            48: ['text-16', 'leading-6', 'py-10', 'px-20', 'min-h-48', 'rounded-12'],
            40: ['text-14', 'py-8', 'px-16', 'min-h-40', 'rounded-[0.625rem]'],
            32: ['text-12', 'py-6', 'px-12', 'min-h-32', 'rounded-8'],
            24: ['text-11', 'py-4', 'px-8', 'min-h-24', 'after:-mt-1', 'rounded-[0.375rem]'],
        },
        justifyContent: {
            center: 'justify-center',
            'flex-start': 'justify-start',
            'flex-end': 'justify-end',
        },
        fixedIcon: { true: undefined },
    },
    compoundVariants: [
        {
            justifyContent: undefined,
            fixedIcon: true,
            className: 'justify-between',
        },
        {
            justifyContent: undefined,
            fixedIcon: false,
            className: 'justify-center',
        },
    ],
    defaultVariants: { size: DEFAULT_SIZE, variant: DEFAULT_VARIANT },
});
